import { render, staticRenderFns } from "./PrivateTv.vue?vue&type=template&id=7346681b&scoped=true&"
import script from "./PrivateTv.vue?vue&type=script&lang=js&"
export * from "./PrivateTv.vue?vue&type=script&lang=js&"
import style0 from "./PrivateTv.vue?vue&type=style&index=0&id=7346681b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7346681b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7346681b')) {
      api.createRecord('7346681b', component.options)
    } else {
      api.reload('7346681b', component.options)
    }
    module.hot.accept("./PrivateTv.vue?vue&type=template&id=7346681b&scoped=true&", function () {
      api.rerender('7346681b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrivateTv.vue"
export default component.exports